export const MARKETING_SITE_URL =
  process.env.REACT_APP_MARKETING_SITE_URL || '/';

export const getMarketingSiteUrl = (path = '/', locale = 'en') => {
  const baseUrl = MARKETING_SITE_URL.replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const localizedPath =
    locale?.toLowerCase()?.startsWith('fr')
      ? `/fr${normalizedPath}`
      : normalizedPath;

  return `${baseUrl}${localizedPath}`;
};
